import { BlockWrapper, smartProps, defineBlock, useInspectorControl, ChildrenBlock } from '@smartfire/js-block-engine';
import Inspector from './inspector';
import clsx from 'clsx';
import style from './block.module.scss';
import Sun from '../components/sun';

const ImageText = ({ background, reverseCols, smallMargin, reverseMobile, hideMobile, sun, sunMobile, anchorId }) => {
    useInspectorControl(Inspector);

    return (
        <BlockWrapper.Div
            id={'anchor-' + anchorId}
            className={clsx(style.block, background === 'blue' && style.blue, sunMobile && style.hasSunOnMobile)}
        >
            {sun && <Sun />}
            <ChildrenBlock
                className={clsx(
                    style.content,
                    reverseCols && style.reverseCols,
                    reverseMobile && style.reverseMobile,
                    hideMobile && style.hideMobile,
                    smallMargin && style.smallMargin,
                )}
                gutenbergEditorConfig={{
                    orientation: 'horizontal',
                    allowedBlocks: [
                        'smartfire/image-text---image-text-col-left',
                        'smartfire/image-text---image-text-col-right',
                    ],
                    template: [
                        ['smartfire/image-text---image-text-col-left', {}],
                        ['smartfire/image-text---image-text-col-right', {}],
                    ],
                }}
                childrenProps={{ smallMargin: smallMargin, background: background }}
            />
        </BlockWrapper.Div>
    );
};

export default defineBlock({
    Block: ImageText,
    smartProps: {
        reverseCols: smartProps.bool.withDefault(false),
        reverseMobile: smartProps.bool.withDefault(false),
        smallMargin: smartProps.bool.withDefault(false),
        hideMobile: smartProps.bool.withDefault(false),
        background: smartProps.string.withDefault('white'),
        sun: smartProps.bool.withDefault(false),
        sunMobile: smartProps.bool.withDefault(false),
        anchorId: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'Image et text',
    },
});
